import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Form,
  Input,
  Label,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import PublicFooter from "../../containers/Public/PublicFooter";
import { addUserCredential } from "../../redux/actions/user-credential";
import { login } from "../../http/http-calls";
import regexConfig from "../../config/regex-config";
import jwt_decode from "jwt-decode";
import { showToast } from "../../helper-methods";

const LoginPage = () => {
  // navigation
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //state
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    handle: "",
    password: "",
  });
  const [isDirty, setIsDirty] = useState({
    handle: false,
    password: false,
  });
  const [errors, setErrors] = useState({});

  // login
  const _loginHandler = async () => {
    const newIsDirty = { ...isDirty };
    Object.keys(isDirty).forEach((each) => (newIsDirty[each] = true));
    const error = _validateForm(formData, newIsDirty);
    if (!error) {
      //api call
      try {
        const res = await login(formData);
        // console.log("login>>", res);
        showToast("Successfully logged in!", "success");
        const token = res.token;
        let user = jwt_decode(token);
        // console.log(user);
        dispatch(addUserCredential({ token: res.token, user: user }));
        navigate("/groups");
      } catch (error) {
        console.log(error);
        showToast(error.reason, "error");
      }
    }
  };

  //on Change
  const _handelOnChange = (field, event) => {
    const newFormData = { ...formData };
    const newIsDirty = { ...isDirty };
    newFormData[field] = event.target.value;
    newIsDirty[field] = true;
    setFormData(newFormData);
    setIsDirty(newIsDirty);
    _validateForm(newFormData, newIsDirty);
  };

  //validation form
  const _validateForm = (data, dirties) => {
    const newErrors = { ...errors };

    Object.keys(dirties).forEach((each) => {
      if (each === "handle" && dirties[each]) {
        if (!data.handle.trim()) {
          newErrors.handle = "*Required";
        } else if (
          data.handle.trim().length &&
          !new RegExp(regexConfig.email).test(data.handle)
        ) {
          newErrors.handle = "*Please enter a valid email ID";
        } else {
          delete newErrors[each];
          dirties[each] = false;
        }
      } else if (each === "password" && dirties[each]) {
        if (!data.password.trim()) {
          newErrors.password = "*Required";
        } else if (data.password.trim().length < 8) {
          newErrors.password = "*You must enter atleast 8 character*";
        } else if (
          data.password.trim().length &&
          !new RegExp(regexConfig.password).test(data.password)
        ) {
          newErrors.password =
            "*Password must contain one upperCase one special Characters some numbers and Characters";
        } else {
          delete newErrors[each];
          dirties[each] = false;
        }
      }
    });
    setIsDirty(dirties);
    setErrors(newErrors);
    return Object.keys(newErrors).length ? true : false;
  };

  return (
    <>
      <div className="authWrapper">
        <div className="loginWrap">
          {/* logo */}
          <img
            src={require("../../assets/img/company-logo.png")}
            alt="Brand Logo"
            className="companyLogo"
          />

          <Form>
            <h2>Login</h2>

            {/* username */}
            <div className="mb-3">
              <Label>Email</Label>
              <InputGroup>
                <Input
                  placeholder="Enter"
                  onChange={(event) => _handelOnChange("handle", event)}
                />
                <InputGroupText>
                  <i className="far fa-envelope"></i>
                </InputGroupText>
              </InputGroup>

              {/* show this when you get any error */}
              {errors.handle ? (
                <div className="form-error">{errors.handle}</div>
              ) : null}
            </div>

            {/* password */}
            <div className="mb-2">
              <Label>Password</Label>
              <InputGroup>
                <Input
                  placeholder="Enter"
                  type={`${showPassword ? "text" : "password"}`}
                  onChange={(event) => _handelOnChange("password", event)}
                />
                <InputGroupText
                  className="cursorPointer"
                  onClick={() => {
                    setShowPassword(!showPassword);
                  }}
                >
                  <i
                    className={`far ${
                      showPassword ? "fa-eye" : "fa-eye-slash"
                    }`}
                  ></i>
                </InputGroupText>
              </InputGroup>

              {/* show this when you get any error */}
              {errors.password ? (
                <div className="form-error">{errors.password}</div>
              ) : null}
            </div>

            <div className="text-end">
              <Link to="/forgot-password" className="forgotPassword">
                Forgot Password?
              </Link>
            </div>

            {/* submit button */}
            <Button
              onClick={() => _loginHandler()}
              color="primary"
              className="btn-submit"
            >
              Login
            </Button>
          </Form>
        </div>

        {/* footer */}
        <PublicFooter />
      </div>
    </>
  );
};

export default LoginPage;
